<script setup>
	import { defineProps } from 'vue'

	const props = defineProps(['title', 'description', 'isEmpty'])
</script>

<template>
  <div class="relative w-full h-[calc(100vh_-_128px)]">
	  <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <div v-if="isEmpty" class="text-center">
          <p class="text-4xl block font-bold text-[var(--color)] mb-4">:(</p>
          <b class="text-xl pb-2 block">{{ title }}</b>
          <small class="font-thin text-zinc-600">{{ description }}</small>
        </div>
        <div v-else>
          <div class="loader"></div>
        </div>
    </div>
  </div>
</template>

<style scoped>
.loader {
  width: 50px;
  aspect-ratio: 1;
  background: #fff;
  border-radius: 50%;
  animation: l1 3s infinite linear;
  position: relative;
}
.loader:before {
  content: "";
  width: 50%;
  height: 50%;
  background: #fee567;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  border-radius: 50%;
  border-bottom: 5px solid #fecd2a;
}
.loader:after {
  content: "";
  width: 50%;
  height: 50%;
  position: absolute;
  top: 25%;
  left: 25%;
  border-radius: 50%;
  border-top: 5px solid #fff1b3;
  transform: rotate(-45deg);
}
@keyframes l1{
  12.5% {border-radius: 37% 63% 70% 30% / 30% 62% 38% 70%}
  25%   {border-radius: 50% 50% 70% 30% / 52% 62% 38% 48%}
  37.5% {border-radius: 33% 67% 18% 82% / 52% 75% 25% 48%}
  50%   {border-radius: 73% 27% 18% 82% / 52% 32% 68% 48%}
  62.5% {border-radius: 73% 27% 74% 26% / 64% 32% 68% 36%}
  75%   {border-radius: 84% 16% 15% 85% / 55% 79% 21% 45%}
  87.5% {border-radius: 12% 88% 69% 31% / 10% 66% 34% 90%}
}
</style>